import { Component, h, Host, State } from '@stencil/core';
import moment from 'moment';
import 'moment-timezone';

@Component({
  tag: 'rdm-site-message',
  styleUrl: 'rdm-site-message.css',
  shadow: false,
})
export class RdmSiteMessage {

    @State() _message: any = { name: '', message: '' };

    @State() _class: string = 'hidden';

    @State() display: string;

    originalPaddingTop: string = '';
    resizeObserver: ResizeObserver;

    async componentDidLoad() {
        const hostname = this._getHostName();
        try {
            const API_URL = "https://content.reece.com.au/api/f43b0181-6ee9-4539-b3e9-f7f37a95f962";
            const libraryId = "25d70bab-53bb-47a4-9f72-01e25b9e4047";
            const contentType = "RDM Site Message";
            const resp = await fetch(`${API_URL}/delivery/v1/search?&fl=document:[json]&q=type:(${contentType}) AND status:ready&fq=libraryId:(${libraryId})&fq=categories:(Reece website domain/${hostname})&rows=2147483647`);
            if (resp.status === 200) {
                const data = await resp.json();
                this._processMessages(data);
            } else if (resp.status < 200 || resp.status >= 300) {
                throw Error("Site message service unavailable");
            }
        } catch (e) {
            console.log("Something went wrong");
        }

        this.observeElements();

        const closeButton = document.querySelector('.rdm-site-message-close');
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                this.pageWrapperAction();
            });
        }
        window.addEventListener('resize', this.handleResize.bind(this));

        this.resizeObserver = new ResizeObserver(() => {
            this.handleResize();
        });

        const siteMessage = document.querySelector('#rdm-site-message');
        const pageWrapper = document.querySelector('.page-wrapper');
        if (siteMessage) {
            this.resizeObserver.observe(siteMessage);
        }
        if (pageWrapper) {
            this.resizeObserver.observe(pageWrapper);
        }
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize.bind(this));
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    handleResize() {
        const siteMessage = document.querySelector('#rdm-site-message');
        const pageWrapper = document.querySelector('.page-wrapper');
        if (siteMessage && pageWrapper) {
            this.applyStyles(siteMessage, pageWrapper);
        }
    }

    pageWrapperAction() {
        const pageWrapper = document.querySelector('.page-wrapper');
        if (pageWrapper) {
            pageWrapper['style'].paddingTop = this.originalPaddingTop;
        }
    }

    observeElements() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach(mutation => {
                if (mutation.type === 'childList') {
                    const siteMessage = document.querySelector('#rdm-site-message');
                    const pageWrapper = document.querySelector('.page-wrapper');
                    if (siteMessage && pageWrapper) {
                        this.storeInitialPaddingTop(pageWrapper);
                        this.applyStyles(siteMessage, pageWrapper);
                        observer.disconnect(); // Stop observing once elements are found and styled
                    }
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    storeInitialPaddingTop(pageWrapper) {
        if (!this.originalPaddingTop) {
            const computedStyle = window.getComputedStyle(pageWrapper);
            this.originalPaddingTop = computedStyle.getPropertyValue('padding-top');
        }
    }

    applyStyles(siteMessage, pageWrapper) {
        this.storeInitialPaddingTop(pageWrapper);

        const header: HTMLElement = document.querySelector('#page-header');
        const headerHeight = header && header.offsetHeight;

        const styles = {
            zIndex: '9',
            width: '100%',
            position: 'relative',
            marginTop: this.originalPaddingTop === '0px' ? '' : (headerHeight ? `${headerHeight}px` : '200px'),
            boxSizing: 'border-box'
        };

        Object.assign(siteMessage['style'], styles);

        const mediaQuery = window.matchMedia('(max-width: 767px)');
        const mobileQuerySiteMsg = window.matchMedia('(min-width: 768px) and (max-width: 1200px)');
        const mobileQuery = window.matchMedia('(max-width: 767px)');

        const handleMediaQuery = (mediaQuery) => {
            const isVisible = siteMessage['style'].display !== 'none';
            const hasHiddenClass = siteMessage.classList.contains('hidden');
        
            if (isVisible && !hasHiddenClass) {
                if (mediaQuery.matches) {
                    pageWrapper['style'].paddingTop = 'inherit';
                } else {
                    pageWrapper['style'].paddingTop = 'inherit';
                }
            } else {
                pageWrapper['style'].paddingTop = '';
            }
        };

        const handleMediaMobileQuery = (mobileQuery) => {
            if (mobileQuery.matches) {
                const header: HTMLElement = document.querySelector('#page-header');
                const headerHeight = header && header.offsetHeight;
    
                const searchBar: HTMLElement = document.querySelector('search-bar');
                const searchBarHeight = searchBar && searchBar.offsetHeight;

                siteMessage['style'].marginTop = this.originalPaddingTop === '0px' ? '' : (headerHeight ? `${headerHeight + (searchBarHeight ? searchBarHeight : 0)}px` : '150px');
            }
        };

        const handleMediaMobileQuerySiteMsg = (mobileQuerySiteMsg) => {
            if (mobileQuerySiteMsg.matches) {
                const header: HTMLElement = document.querySelector('#page-header');
                const headerHeight = header && header.offsetHeight;

                siteMessage['style'].marginTop = this.originalPaddingTop === '0px' ? '' : (headerHeight ? `${headerHeight}px` : '114px');
            }
        };

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'style') {
                    handleMediaQuery(mediaQuery);
                }
            });
        });

        observer.observe(siteMessage, { attributes: true });

        handleMediaQuery(mediaQuery); // Apply the style on page load
        handleMediaMobileQuery(mobileQuery);
        handleMediaMobileQuerySiteMsg(mobileQuerySiteMsg);


        mediaQuery.addListener(handleMediaQuery);
        mobileQuery.addListener(handleMediaMobileQuery);
        mobileQuerySiteMsg.addListener(handleMediaMobileQuerySiteMsg);
    }

    _processMessages(data) {
        if (typeof data === 'object') {
            const hostname = this._getHostName();
            const currentPath = window.location.pathname;

            const filteredData = data?.documents?.filter(el => el?.document?.elements?.enabled?.value === true);
            const lastElement = filteredData?.length > 0 ? [filteredData[filteredData.length - 1]] : [];
            lastElement.forEach(m => {
                const name = m?.document?.elements?.name?.value;
                const message = m?.document?.elements?.message?.value;
                const type = m?.document?.elements?.type?.value?.selection;
                const domains = m?.document?.elements?.domain?.categories?.map(domain => {
                    const parts = domain.split('/');
                    return parts.length > 1 ? parts[1] : null;
                });
                const path = m?.document?.elements?.path?.value;
                const isEnabled = m?.document?.elements?.enabled?.value;
                const timezone = m?.document?.elements?.timezone?.value?.selection;
                const activeFrom = moment.utc(m?.document?.elements?.activeFrom?.value).tz(timezone);
                const activeTill = moment.utc(m?.document?.elements?.activeTill?.value).tz(timezone);

                const currentTime = moment.utc().tz(timezone);

                const isValid = currentTime.isBetween(activeFrom, activeTill);

                if (domains.includes(hostname) && (!path || (path && currentPath.includes(path))) && isEnabled && isValid && this._shouldDisplayBanner()) {
                    this._message.name = name;
                    this._message.message = message;
                    if (type === 'information') this._class = 'rdm-alert rdm-alert-success';
                    if (type === 'warning') this._class = 'rdm-alert rdm-alert-warning';
                    if (type === 'error') this._class = 'rdm-alert rdm-alert-danger';
                    this.display = 'block';
                } else {
                    this.display = 'none';
                }
            });
        }
    }

    _getHostName() {
        const fullHostname = window.location.hostname;

        if (fullHostname.startsWith("www.")) {
            return fullHostname.slice(4);
        }

        return fullHostname;
    }

    _close() {
        document.getElementById('rdm-site-message').style.display = 'none';
        sessionStorage.setItem('BANNER_STATE', 'closed');
    }

    _shouldDisplayBanner() {
        return !sessionStorage.getItem('BANNER_STATE');
    }

    render() {

        return (
            <Host>
                <div id="rdm-site-message" class={this._class} style={{ display: this.display }}>
                    <button type="button" class="close rdm-site-message-close" onClick={this._close} data-dismiss="alert">×</button>
                    <div class="rdm-content-container">
                        <b>{this._message.name}</b>
                        <p class="description" innerHTML={this._message.message}></p>
                    </div>
                </div>
            </Host>
        );
    }
}
